/**
 * Grabs the CSRF token from its home in a meta tag
 *
 * @returns {String}
 */
export default function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
}
